import axios from "axios";
const { TIME_API_SERVER_URL } = process.env;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
export const timeAPIAxios = axios.create({
  baseURL: "https://api.iaidimage.com/app/",
  // withCredentials: true,
});

//baseURL: `${TIME_API_SERVER_URL || "192.168.0.10:3000"}/api`,
